import type { FallbackRender } from "@sentry/react";

/**
 * Minimal fallback UI for lexsite. Marketing site keeps it short +
 * reassuring — no stack-trace exposure to public visitors.
 */
export const SentryFallback: FallbackRender = ({ resetError }) => {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-white p-8 text-slate-900">
      <div className="max-w-md text-center">
        <h1 className="mb-2 text-2xl font-semibold">Something went wrong</h1>
        <p className="mb-6 text-sm text-slate-600">
          We hit an unexpected error. The team has been notified.
        </p>
        <div className="flex justify-center gap-3">
          <button
            type="button"
            onClick={resetError}
            className="rounded bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700"
          >
            Try again
          </button>
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="rounded border border-slate-300 px-4 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50"
          >
            Reload page
          </button>
        </div>
      </div>
    </div>
  );
};
